// Calculates the discounted price for one unit at a given iteration.
export const calculatePriceForIteration = (price, discount, iteration) => {
    return Math.round(price * Math.pow(1 - discount / 100, iteration));
  };
  
  // Calculates the total price for a product given its price, discount, and count.
  export const calculateProductTotal = (price, discount, count) => {
    if (count === 0) return 0;
    let total = 0;
    for (let i = 0; i < count; i++) {
      total += calculatePriceForIteration(price, discount, i);
    }
    return total;
  };
  
  // Calculates the average price per unit for the main product.
  export const calculateProductAverage = (price, discount, count) => {
    return count === 0
      ? 0
      : Math.round(calculateProductTotal(price, discount, count) / count);
  };
  
  // Calculates the average discount percentage over a series of items.
  export const calculateDiscountPercentageAverage = (discount, count) => {
    if (count === 0) return 0;
    let totalPercentage = 0;
    for (let i = 0; i < count; i++) {
      totalPercentage += Math.round(Math.pow(1 - discount / 100, i) * 100);
    }
    return Math.round(totalPercentage / count);
  };
  
  // Calculates the total for an extra item (addon).
  export const calculateExtraTotal = (price, discount, count) => {
    return calculateProductTotal(price, discount, count);
  };
  
  // Calculates the average price per unit for an extra item.
  export const calculateExtraAverage = (price, discount, count) => {
    return calculateProductAverage(price, discount, count);
  };
  